import { Component, Input, OnInit } from '@angular/core';

const accordion = {
  tamanhos: {
    titulo: {
      normal: 'titulo--normal',
      grande: 'titulo--grande',
    },
  },
};

@Component({
  selector: 'lovers-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements OnInit {
  @Input() public titulo: string = '';
  @Input() public tamanhoTitulo: string = 'normal';
  @Input() public image: string = null;

  public aberto: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  public controlePainel(): void {
    this.aberto = !this.aberto;
  }

  public definirTamanho(campo: string): string {
    return accordion.tamanhos[campo][this.tamanhoTitulo];
  }
}
